import { memo } from "react";
import styled from "styled-components";

const WildfiresTab = () => {
  return (
    <UI_Wrapper>
      Cháy rừng
    </UI_Wrapper>
  );
};

export default memo(WildfiresTab);

const UI_Wrapper = styled.div`

`;